
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="paddle"
export default class extends Controller {
  static values = {
    data: Object,
  };

  connect() {
    this.pay()
  }

  pay() {
    Paddle.Checkout.open(this.dataValue);
  }
}
